<script lang="ts">
	import Picture from '$elements/Picture.svelte';
	import MyAccountButton from '$elements/MyAccountButton.svelte';
</script>

<div class='service-unavailable'>
	<h1 class="pl_headline200 pl_headline300--md service-unavailable__title">Entschuldige, OTTO UP ist gerade nicht
		verfügbar.</h1>

	<Picture src="https://i.otto.de/i/otto/illustration_error" />

	<div class="pl_copy100 service-unavailable__description">
		<p>Dein OTTO UP Vorteilsprogramm ist offline, da es einen technischen Fehler gibt. Du kannst aktuell leider nichts
			tun. Bitte versuche es zu einem späteren Zeitpunkt noch einmal.</p>
		<br>
		<p>Vielen Dank!</p>
	</div>

	<div class="pl_mx175">
		<MyAccountButton />
	</div>
</div>

<style lang='scss'>
  @use '@otto-ec/otto-components-utils/scss/mixins' as mixins;
  @use "@otto-ec/design-tokens/tokens";

  .service-unavailable {
    background-color: tokens.$oc-base-color-white;
    width: 100%;
    padding: tokens.$oc-semantic-spacing-150 0;

    @include mixins.breakpoint(mixins.$breakpoint-m) {
      padding: 40px 0;
    }

    &__title {
      padding-right: tokens.$oc-semantic-spacing-100;
      padding-left: tokens.$oc-semantic-spacing-100;
      padding-bottom: tokens.$oc-semantic-spacing-100;

      @include mixins.breakpoint(mixins.$breakpoint-m) {
        padding-bottom: tokens.$oc-semantic-spacing-150;
      }
    }

    &__description {
      padding: tokens.$oc-semantic-spacing-100 tokens.$oc-semantic-spacing-100 40px tokens.$oc-semantic-spacing-100;

      @include mixins.breakpoint(mixins.$breakpoint-m) {
        padding: tokens.$oc-semantic-spacing-200 tokens.$oc-semantic-spacing-200 40px tokens.$oc-semantic-spacing-200;
        font-size: 16px;
        line-height: 24px;
      }
    }

    &__picture {
      @include mixins.breakpoint(mixins.$breakpoint-m) {
        padding-right: tokens.$oc-semantic-spacing-100;
        padding-left: tokens.$oc-semantic-spacing-100;
      }
    }
  }
</style>
